<script>
    import {onMount} from 'svelte';
    import Logo from './common/Logo.svelte';
    import Space from './common/Space.svelte';
    import config from './config.json';
    const env = MODE || "dev";
    const point = POINT || "ves";
    const location = config[[point]];
    import {feedbackType, feedbackDetail, space, screen} from './stores';
    const type = $feedbackType === "Positive" ? "detailOptionsPositive" : "detailOptionsNegative";

    onMount(async () => {
        setTimeout(() => {
            submit(10);
        }, 30000)
    })

    async function submit(timer) {
        let scaffold = await buildScaffold();
        console.log(scaffold);
        await fetch(config.proxy[[env]], {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Proxy-URL": config.url[[env]],
                Accept: "application/json",
            },
            body: JSON.stringify(scaffold),
        })
        .then(async (response) => {
            return await response.json();
        })
        .then((response) => {
            console.log(response);
            if (response.response === 1) {
            console.log("Response OK");
            setTimeout(() => {
                window.location.reload();
            }, timer);
            } else {
            alert(
                "There was an error with the submission. Try again, but if this continues to happen, contact bradley1@vt.edu."
            );
            console.error("There was an error with the submission: ");
            setTimeout(() => {
                window.location.reload();
            }, timer);
            }
        })
        .catch((error) => {
            alert(
            "There was an error with the submission. Try again, but if this continues to happen, contact bradley1@vt.edu."
            );
            console.error("There was an error with the submission: ");
            console.error(error);
            setTimeout(() => {
                window.location.reload();
            }, timer);
        });
    }

    async function buildScaffold() {
        let tempData = {};
        Object.keys(config.schema[[env]]).forEach((key) => {
            switch(config.schema[[env]][[key]]) {
                case "location.name":
                    tempData[[key]] = location.name;
                    break;
                case "feedbackDetail":
                    tempData[[key]] = $feedbackDetail;
                    break;
                case "feedbackType":
                    tempData[[key]] = $feedbackType;
                    break;
            }
        })
        return [tempData];
    }
</script>

<Logo />
    <h1 class="more-detail">What was {$feedbackType.toLowerCase()} about your experience?</h1>
    <ul class="detail-container">
        {#each config[$space][type] as value}
          <li class='detail-item' on:click={() => {$feedbackDetail = value; submit(15000); $screen = 2}}>{value}</li>
        {/each}
    </ul>
<Space />